import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueTyperPlugin from "vue-typer";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import mixitup from "mixitup";

library.add(faUserSecret);

Vue.use(VueTyperPlugin);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
